import { c } from "react-compiler-runtime";
import { useEffect } from "react";
import { useStore, createStore } from "zustand";
import { HistoryStore } from "@graphiql/toolkit";
import { useExecutionContext, useEditorContext, useStorage } from "@graphiql/react";
const historyStore = createStore((set, get) => ({
  historyStorage: null,
  actions: {
    addToHistory(operation) {
      const {
        historyStorage
      } = get();
      historyStorage.updateHistory(operation);
      set({});
    },
    editLabel(operation, index) {
      const {
        historyStorage
      } = get();
      historyStorage.editLabel(operation, index);
      set({});
    },
    toggleFavorite(operation) {
      const {
        historyStorage
      } = get();
      historyStorage.toggleFavorite(operation);
      set({});
    },
    setActive: (item) => item,
    deleteFromHistory(item, clearFavorites) {
      const {
        historyStorage
      } = get();
      historyStorage.deleteHistory(item, clearFavorites);
      set({});
    }
  }
}));
const HistoryContextProvider = (t0) => {
  const $ = c(12);
  const {
    maxHistoryLength: t1,
    children
  } = t0;
  const maxHistoryLength = t1 === void 0 ? 20 : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      nonNull: true
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const {
    isFetching
  } = useExecutionContext(t2);
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      nonNull: true
    };
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const {
    tabs,
    activeTabIndex
  } = useEditorContext(t3);
  const activeTab = tabs[activeTabIndex];
  const storage = useStorage();
  let t4;
  if ($[2] !== maxHistoryLength || $[3] !== storage) {
    t4 = new HistoryStore(storage, maxHistoryLength);
    $[2] = maxHistoryLength;
    $[3] = storage;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const historyStorage = t4;
  let t5;
  let t6;
  if ($[5] !== historyStorage) {
    t5 = () => {
      historyStore.setState({
        historyStorage
      });
    };
    t6 = [historyStorage];
    $[5] = historyStorage;
    $[6] = t5;
    $[7] = t6;
  } else {
    t5 = $[6];
    t6 = $[7];
  }
  useEffect(t5, t6);
  let t7;
  let t8;
  if ($[8] !== activeTab || $[9] !== isFetching) {
    t7 = () => {
      if (!isFetching) {
        return;
      }
      const {
        addToHistory
      } = historyStore.getState().actions;
      addToHistory({
        query: activeTab.query ?? void 0,
        variables: activeTab.variables ?? void 0,
        headers: activeTab.headers ?? void 0,
        operationName: activeTab.operationName ?? void 0
      });
    };
    t8 = [isFetching, activeTab];
    $[8] = activeTab;
    $[9] = isFetching;
    $[10] = t7;
    $[11] = t8;
  } else {
    t7 = $[10];
    t8 = $[11];
  }
  useEffect(t7, t8);
  return children;
};
function useHistoryStore(selector) {
  return useStore(historyStore, selector);
}
const useHistory = () => {
  return useHistoryStore(_temp);
};
const useHistoryActions = () => {
  return useHistoryStore(_temp2);
};
function _temp(state) {
  return state.historyStorage.queries;
}
function _temp2(state) {
  return state.actions;
}
export {
  HistoryContextProvider,
  useHistory,
  useHistoryActions
};
//# sourceMappingURL=context.js.map
